import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListGeneral = (query) => http.get(`${api}/compras-catalogo/list-general`, { params: { ...query } })

export {
  getListGeneral
}
